module.exports = __webpack_public_path__ + "img/3d45c07.svg";